import React from 'react';
import { POS_VIEW_CLIENT } from '../utils/posSync';

const PosModeTabs = ({ onChange, hasClientConnected = false, className = '' }) => (
  <button
    type="button"
    onClick={() => {
      if (!hasClientConnected) {
        onChange?.(POS_VIEW_CLIENT);
      }
    }}
    disabled={hasClientConnected}
    className={`rounded-lg border px-3 py-2 text-sm font-semibold shadow-sm transition ${
      hasClientConnected
        ? 'border-gray-200 bg-gray-100 text-gray-400 cursor-not-allowed'
        : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-100 hover:text-gray-900'
    } ${className}`.trim()}
    title={hasClientConnected ? 'Cliente conectado' : 'Abrir vista cliente'}
    aria-label={hasClientConnected ? 'Vista cliente conectada' : 'Abrir vista cliente'}
  >
    Cliente
  </button>
);

export default PosModeTabs;
